import { createRequestTypes, action } from '../utils/actions';
import { REQUEST, SUCCESS, FAILURE } from '../utils/constants';

export const GET_ORGANIZATION_LIST = createRequestTypes('GET_ORGANIZATION_LIST');
export const GET_ACTIVE_ORGANIZATIONS = createRequestTypes('GET_ACTIVE_ORGANIZATIONS');
export const GET_INACTIVE_ORGANIZATIONS = createRequestTypes('GET_INACTIVE_ORGANIZATIONS');
export const GET_ORGANIZATION = createRequestTypes('GET_ORGANIZATION');

export const CREATE_ORGANIZATION = createRequestTypes('CREATE_ORGANIZATION');
export const UPDATE_ORGANIZATION = createRequestTypes('UPDATE_ORGANIZATION');
export const UPDATE_ORGANIZATION_BY_ADMIN = createRequestTypes('UPDATE_ORGANIZATION_BY_ADMIN');
export const DELETE_ORGANIZATION = createRequestTypes('DELETE_ORGANIZATION');
export const GET_CHILD_ORGANIZATION = createRequestTypes('GET_CHILD_ORGANIZATION');
export const GET_ORGANIZATION_TYPES = createRequestTypes('GET_ORGANIZATION_TYPES');
export const GET_ORGANIZATION_HIERARCHY = createRequestTypes('GET_ORGANIZATION_HIERARCHY');

export const SET_CHILD_MEMBERS_TABLE_FILTER = 'SET_CHILD_MEMBERS_TABLE_FILTER';
export const SET_CHILD_USERS_TABLE_FILTER = 'SET_CHILD_USERS_TABLE_FILTER';
export const SET_ORGANIZATION_TABLE_FILTER = 'SET_ORGANIZATION_TABLE_FILTER';
export const SET_ORGANIZATION_TABLE_SORTING = 'SET_ORGANIZATION_TABLE_SORTING';

export const TOGGLE_ASSIGN_ORG_MODAL = 'TOGGLE_ASSIGN_ORG_MODAL';

export const getOrganizationList = {
  request: (data) => action(GET_ORGANIZATION_LIST[REQUEST], { data }),
  success: (payload) => action(GET_ORGANIZATION_LIST[SUCCESS], { payload }),
  failure: (payload) => action(GET_ORGANIZATION_LIST[FAILURE], { payload }),
};

export const getActiveOrganizations = {
  request: (data) => action(GET_ACTIVE_ORGANIZATIONS[REQUEST], { data }),
  success: (payload) => action(GET_ACTIVE_ORGANIZATIONS[SUCCESS], { payload }),
  failure: (payload) => action(GET_ACTIVE_ORGANIZATIONS[FAILURE], { payload }),
};

export const getInactiveOrganizations = {
  request: (data) => action(GET_INACTIVE_ORGANIZATIONS[REQUEST], { data }),
  success: (payload) => action(GET_INACTIVE_ORGANIZATIONS[SUCCESS], { payload }),
  failure: (payload) => action(GET_INACTIVE_ORGANIZATIONS[FAILURE], { payload }),
};

export const getOrganizationsHierarchy = {
  request: (data) => action(GET_ORGANIZATION_HIERARCHY[REQUEST], { data }),
  success: (payload) => action(GET_ORGANIZATION_HIERARCHY[SUCCESS], { payload }),
  failure: (payload) => action(GET_ORGANIZATION_HIERARCHY[FAILURE], { payload }),
};

export const getOrganization = {
  request: () => action(GET_ORGANIZATION[REQUEST]),
  success: (payload) => action(GET_ORGANIZATION[SUCCESS], { payload }),
  failure: (payload) => action(GET_ORGANIZATION[FAILURE], { payload }),
};

export const createOrganization = {
  request: (data) => action(CREATE_ORGANIZATION[REQUEST], { data }),
  success: (payload) => action(CREATE_ORGANIZATION[SUCCESS], { payload }),
  failure: (payload) => action(CREATE_ORGANIZATION[FAILURE], { payload }),
};

export const updateOrganization = {
  request: (id, data) => action(UPDATE_ORGANIZATION[REQUEST], { id, data }),
  success: (payload) => action(UPDATE_ORGANIZATION[SUCCESS], { payload }),
  failure: (payload) => action(UPDATE_ORGANIZATION[FAILURE], { payload }),
};

export const updateOrganizationByAdmin = {
  request: (id, data) => action(UPDATE_ORGANIZATION_BY_ADMIN[REQUEST], { id, data }),
  success: (payload) => action(UPDATE_ORGANIZATION_BY_ADMIN[SUCCESS], { payload }),
  failure: (payload) => action(UPDATE_ORGANIZATION_BY_ADMIN[FAILURE], { payload }),
};

export const deleteOrganization = {
  request: (id) => action(DELETE_ORGANIZATION[REQUEST], { id }),
  success: (payload) => action(DELETE_ORGANIZATION[SUCCESS], { payload }),
  failure: (payload) => action(DELETE_ORGANIZATION[FAILURE], { payload }),
};

export const getChildOrganization = {
  request: (id) => action(GET_CHILD_ORGANIZATION[REQUEST], { id }),
  success: (payload) => action(GET_CHILD_ORGANIZATION[SUCCESS], { payload }),
  failure: (payload) => action(GET_CHILD_ORGANIZATION[FAILURE], { payload }),
};

export const getOrganizationTypes = {
  request: () => action(GET_ORGANIZATION_TYPES[REQUEST]),
  success: (payload) => action(GET_ORGANIZATION_TYPES[SUCCESS], { payload }),
  failure: (payload) => action(GET_ORGANIZATION_TYPES[FAILURE], { payload }),
};

export const setOrganizationTableFilter = (payload) => ({
  type: SET_ORGANIZATION_TABLE_FILTER,
  payload,
});

export const setOrganizationTableSorting = (payload) => ({
  type: SET_ORGANIZATION_TABLE_SORTING,
  payload,
});

export const setChildMembersTableFilter = (payload) => ({
  type: SET_CHILD_MEMBERS_TABLE_FILTER,
  payload,
});

export const setChildUsersTableFilter = (payload) => ({
  type: SET_CHILD_USERS_TABLE_FILTER,
  payload,
});

export const toggleAssignOrgModal = (payload) => ({
  type: TOGGLE_ASSIGN_ORG_MODAL,
  payload,
});
